import {ReqItemList} from "@/api";
import { Modal, use_modal } from '@/components/modal';

import Picture from '@/components/picture';
import {
	mapState,mapMutations
} from "vuex";


export default {
	components: {

		'c-picture': Picture,
		'c-modal': Modal,
	},

	data() { 
		return {
			TimerForTime:0,
			timerForUpdate:0,
		}; 
	},
	computed: {
		...mapState(["user","tradeOfferBox"])
	},
	created() {

		if(this.user.nickname) {
			this.RequestTradeOffer();
		}

		this.TimerForTime = setInterval(() => {
			this.tradeOfferBox.list.forEach(function(item){
				if(item.state < 2 )
					item.time++;
			});
		},1000);

		this.timerForUpdate = setInterval(() => {
			if(this.tradeOfferBox.list.length > 0){
				if(this.user.nickname) {
					this.RequestTradeOffer();
				}
				else
				{
					this.tradeOfferBox.list = [];
				}
			}
		},5000);
	},
	methods: {
		...mapMutations(["setloginModal","RequestTradeOffer","switch_tradeofferbox_show"]),
		deleteRow(index){
			this.tradeOfferBox.list.splice(index,1);
		}
	},

};
